/* Copyright (c) 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  useCreateReportMutation,
  CreateReportInput,
} from "~/generated/graphql";
import { showSuccess, showError } from "~/services/toast";

export function useCreateReport() {
  const [createReportMutation, { loading }] = useCreateReportMutation({
    onCompleted: (response) => {
      if (response?.createReport?.id) {
        showSuccess(
          "Your CSV report is being generated. Redirecting to 'Reports'...",
          { type: "info" }
        );
      } else {
        showError("There was an issue with generating the report.");
      }
    },
    onError: (error) => {
      showError(`Failed to generate the report: ${error.message}`);
    },
  });

  async function createReport(
    data: CreateReportInput
  ): Promise<string | undefined> {
    const result = await createReportMutation({
      variables: {
        input: data,
      },
    });

    return result.data?.createReport.id;
  }

  return [createReport, loading] as const;
}
